import React from 'react';
import FaIcon from '../../../Elements/FaIcon';

export default function ChatInput({ input, setInput, onSend, disabled, inputRef }) {
  const onKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!disabled) onSend();
    }
  };
  const grow = (e) => {
    setInput(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = Math.min(e.target.scrollHeight, 168) + 'px';
  };
  const sendDisabled = disabled || !input.trim();

  return (
    <div className='ac-composer'>
      <div className='ac-composer-inner'>
        <div className='ac-composer-box'>
          <textarea
            ref={inputRef}
            rows={1}
            placeholder='Message Bravo Assistant…'
            value={input}
            onChange={grow}
            onKeyDown={onKey}
          />
          <button className='ac-send' onClick={onSend} disabled={sendDisabled} aria-label='Send'>
            <FaIcon iconName='fa-solid fa-paper-plane' />
          </button>
        </div>
        <div className='ac-composer-foot'>
          <span>Bravo Assistant can make mistakes — verify important operations data.</span>
          <span>
            <kbd>Enter</kbd> to send · <kbd>Shift</kbd>+<kbd>Enter</kbd> for new line
          </span>
        </div>
      </div>
    </div>
  );
}
